import { API, api as adminApi } from "./api";

// ---- Public shop (no auth) ----
export const shopFetch = async (path, options = {}) => {
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  const r = await fetch(`${API}${path}`, { ...options, headers });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.detail || "Error");
  return data;
};

// ---- Shopper auth ----
const SHOPPER_KEY = "elnav_shopper_token";
const SHOPPER_INFO = "elnav_shopper_info";

export const shopperAuth = {
  token: () => localStorage.getItem(SHOPPER_KEY),
  info: () => {
    try { return JSON.parse(localStorage.getItem(SHOPPER_INFO) || "null"); } catch { return null; }
  },
  save: (token, shopper) => {
    localStorage.setItem(SHOPPER_KEY, token);
    localStorage.setItem(SHOPPER_INFO, JSON.stringify(shopper));
  },
  clear: () => {
    localStorage.removeItem(SHOPPER_KEY);
    localStorage.removeItem(SHOPPER_INFO);
  },
  isAuthed: () => !!localStorage.getItem(SHOPPER_KEY),
};

export const shopperFetch = async (path, options = {}) => {
  const t = shopperAuth.token();
  const headers = {
    "Content-Type": "application/json",
    ...(t ? { Authorization: `Bearer ${t}` } : {}),
    ...(options.headers || {}),
  };
  const r = await fetch(`${API}${path}`, { ...options, headers });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.detail || "Error");
  return data;
};

const qs = (params) =>
  new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();

// ---- Public shop API ----
export const shopApi = {
  listProducts: (params = {}) => {
    const q = qs(params);
    return shopFetch(`/shop/products${q ? `?${q}` : ""}`);
  },
  getProduct: (slug) => shopFetch(`/shop/products/${slug}`),
  categories: () => shopFetch(`/shop/categories`),
  register: (body) => shopFetch(`/shop/register`, { method: "POST", body: JSON.stringify(body) }),
  login: (body) => shopFetch(`/shop/login`, { method: "POST", body: JSON.stringify(body) }),
  me: () => shopperFetch(`/shop/me`),
  myOrders: () => shopperFetch(`/shop/my-orders`),
  wishlist: () => shopperFetch(`/shop/wishlist`),
  toggleWishlist: (pid) => shopperFetch(`/shop/wishlist/toggle/${pid}`, { method: "POST" }),
  checkout: (body) => shopFetch(`/shop/checkout`, { method: "POST", body: JSON.stringify(body) }),
};

// ---- Admin inventory + products API (uses admin JWT via api()) ----
export const inventoryApi = {
  listProducts: (params = {}) => {
    const q = qs(params);
    return adminApi(`/admin/products${q ? `?${q}` : ""}`);
  },
  byBarcode: (bc) => adminApi(`/admin/products/by-barcode/${encodeURIComponent(bc)}`),
  getProduct: (id) => adminApi(`/admin/products/${id}`),
  createProduct: (body) => adminApi(`/admin/products`, { method: "POST", body }),
  patchProduct: (id, body) => adminApi(`/admin/products/${id}`, { method: "PATCH", body }),
  deleteProduct: (id) => adminApi(`/admin/products/${id}`, { method: "DELETE" }),
  adjustStock: (id, body) => adminApi(`/admin/products/${id}/adjust`, { method: "POST", body }),
  dashboard: () => adminApi(`/admin/inventory/dashboard`),
  history: (pid) => adminApi(`/admin/inventory/history${pid ? `?product_id=${pid}` : ""}`),
  listOrders: (status) => adminApi(`/admin/orders${status ? `?status_filter=${status}` : ""}`),
  getOrder: (id) => adminApi(`/admin/orders/${id}`),
  patchOrder: (id, body) => adminApi(`/admin/orders/${id}`, { method: "PATCH", body }),
  listShoppers: () => adminApi(`/admin/shoppers`),
  categories: () => shopFetch(`/shop/categories`),
};
